import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SessionService } from '../../shared/services/session.service';
import * as $ from "jquery";

//import { FKStAlphabetshelfComponent } from '../fk-st-alphabetshelf/fk-st-alphabetshelf.component';
//import { FKStMemorygameComponent } from '../fk-st-memorygame/fk-st-memorygame.component';
//import { FKStWordpuzzleComponent } from '../fk-st-wordpuzzle/fk-st-wordpuzzle.component';
import { FKStWriteownwordComponent } from '../fk-st-writeownword/fk-st-writeownword.component';
//import { FKStHearthesoundComponent } from '../fk-st-hearthesound/fk-st-hearthesound.component';

//import { FKStLyssnaEfterLjudetComponent } from '../fk-st-lyssna-efter-ljudet/fk-st-lyssna-efter-ljudet.component';
//import { FKStSangAlfabetetComponent } from '../fk-st-sang-alphabet/fk-st-sang-alphabet.component';


//import { FKStCharacterOComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-o/fk-st-character-o.component';
//import { FKStCharacterMComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-m/fk-st-character-m.component';
//import { FKStCharacterSComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-s/fk-st-character-s.component';
//import { FKStCharacterLComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-l/fk-st-character-l.component';
//import { FKStCharacterAComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-a/fk-st-character-a.component';
//import { FKStCharacterEComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-e/fk-st-character-e.component';
//import { FKStCharacterIComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-i/fk-st-character-i.component';
//import { FKStCharacterBComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-b/fk-st-character-b.component';
//import { FKStCharacterCComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-c/fk-st-character-c.component';
//import { FKStCharacterDComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-d/fk-st-character-d.component';
//import { FKStCharacterGComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-g/fk-st-character-g.component';
//import { FKStCharacterHComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-h/fk-st-character-h.component';
//import { FKStCharacterJComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-j/fk-st-character-j.component';
//import { FKStCharacterKComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-k/fk-st-character-k.component';
//import { FKStCharacterNComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-n/fk-st-character-n.component';
//import { FKStCharacterPComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-p/fk-st-character-p.component';
//import { FKStCharacterQComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-q/fk-st-character-q.component';
//import { FKStCharacterRComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-r/fk-st-character-r.component';
//import { FKStCharacterTComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-t/fk-st-character-t.component';
//import { FKStCharacterUComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-u/fk-st-character-u.component';
//import { FKStCharacterVComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-v/fk-st-character-v.component';
//import { FKStCharacterWComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-w/fk-st-character-w.component';
//import { FKStCharacterASComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-a-s/fk-st-character-a-s.component';
//import { FKStCharacterASSComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-a-ss/fk-st-character-a-ss.component';
//import { FKStCharacterOSComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-o-s/fk-st-character-o-s.component';
//import { FKStCharacterFComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-f/fk-st-character-f.component';
//import { FKStCharacterXComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-x/fk-st-character-x.component';
//import { FKStCharacterYComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-y/fk-st-character-y.component';
//import { FKStCharacterZComponent } from '../../fk-studentweb/fk-st-swedishcharacter/fk-st-character-z/fk-st-character-z.component';

@Component({
  selector: 'app-fk-st-studenthome',
  templateUrl: './fk-st-studenthome.component.html',
  styleUrls: ['./fk-st-studenthome.component.scss']
})
export class FKStudentHomeComponent implements OnInit, AfterViewInit {
  public bloburl: string;
  public mydevice: string = "";
  dialogResult = "";
  constructor(private sessionService: SessionService, public dialog: MatDialog) { this.bloburl = this.sessionService.bloburl; }

  ngOnInit() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var chrome_browser = userAgent.indexOf("chrome") > -1;
    var samsung_browser = userAgent.indexOf("samsung") > -1;
  if(isIOS)
  {
    this.mydevice = "ipad";
  }
  else if (android_dev) {
    this.mydevice = "android";

    if (samsung_browser) {
      this.mydevice = this.mydevice + "_samsung";
    }
    else if (chrome_browser) {
      this.mydevice = this.mydevice + "_chrome";

    }
    var body = document.body;
    body.classList.add(this.mydevice);
  }
    var strbloburl = this.sessionService.bloburl;
    // var mainleftmenu = document.getElementById("opennavbutton");
    $(".rb_ch").hide();
    $(".wb_ch").hide();
    // $(".main").css({ "margin-left": "12.5%" });
    // mainleftmenu.style.display = "block";
    // $("#opennavbutton").show();
    // $("#closenavbutton").hide();
    // $('#opennavbutton').css("opacity", 1);
    // $('#closenavbutton').css("opacity", 1);
    // $(".sidenav").css('margin-left', "0%");
  }

  //openmemory() {

  //  let dialogRef = this.dialog.open(FKStMemorygameComponent, {
  //    disableClose: true,

  //  });

  //}


  //openwordpuzzle() {

  //  let dialogRef = this.dialog.open(FKStWordpuzzleComponent, {
  //    disableClose: true
  //  });

  //}

  openwriteownword() {

    let dialogRef = this.dialog.open(FKStWriteownwordComponent, {
      disableClose: true
    });

  }


  //openalphabetshelf() {

  //  let dialogRef = this.dialog.open(FKStAlphabetshelfComponent, {
  //    disableClose: true
  //  });

  //}
  //opensangAlfabetet() {

  //  let dialogRef = this.dialog.open(FKStSangAlfabetetComponent, {
  //    disableClose: true
  //  });

  //}

  on() {
    document.getElementById("fk_sw_character_overlay").style.display = "block";
    document.getElementById("fk_sw_character_imageTable").style.display = "table";
}

off() {
  document.getElementById("fk_sw_character_overlay").style.display = "none";
  document.getElementById("fk_sw_character_imageTable").style.display = "none";
}
  on1() {
    document.getElementById("fk_sw_redbox_overlay").style.display = "block";
    document.getElementById("fk_sw_redbox_imageTable").style.display = "table";
  }

  off1() {
    document.getElementById("fk_sw_redbox_overlay").style.display = "none";
    document.getElementById("fk_sw_redbox_imageTable").style.display = "none";
  }
  openswedishcharacter(i) {
    var comparr: any[string];
    comparr = [
      //FKStCharacterAComponent, FKStCharacterBComponent, FKStCharacterCComponent, FKStCharacterDComponent, FKStCharacterEComponent,
      //FKStCharacterFComponent, FKStCharacterGComponent, FKStCharacterHComponent, FKStCharacterIComponent, FKStCharacterJComponent, FKStCharacterKComponent,
      //FKStCharacterLComponent, FKStCharacterMComponent, FKStCharacterNComponent, FKStCharacterOComponent, FKStCharacterPComponent, FKStCharacterQComponent,
      //FKStCharacterRComponent, FKStCharacterSComponent, FKStCharacterTComponent, FKStCharacterUComponent, FKStCharacterVComponent, FKStCharacterWComponent,
      //FKStCharacterXComponent, FKStCharacterYComponent, FKStCharacterZComponent, FKStCharacterASComponent, FKStCharacterASSComponent, FKStCharacterOSComponent, FKStLyssnaEfterLjudetComponent, FKStHearthesoundComponent
    ];
    let dialogRef = this.dialog.open(comparr[i], {
      disableClose: true
    });
    this.off();
    this.off1();
  }
  async ngAfterViewInit() {

    await this.loadScript('../../../../assets/fk-commonjs/scripts/custom.js');


  }
  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }

}
